<template>
  <div id="rsid-datepicker">
    <button @click="showModal = true" v-if="!showModal">{{ dates }}</button>
    <modal v-if="showModal" @close="showModal = false">
      <h3 slot="header"></h3>
      <div slot="body">
        <Calendar v-model="rangesData" @cancel="showModal = false" @submit="changeRangesData()" />
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
import Modal from "./Modal";
import Calendar from "./components/Calendar/Calendar.vue";

export default {
  name: "app",
  components: {
    Calendar,
    Modal
  },
  data() {
    return {
      rangesData: {
        rangesPromo: null,
        dates: null,
        fullDates: null
      },
      dates: null,
      showModal: false
    };
  },
  methods: {
    showDates() {
      let locale = window.navigator.language.toLowerCase().slice(0,2);
      if (this.rangesData.dates) {
        let option = {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "numeric"
        };
        let format = new Intl.DateTimeFormat(window.navigator.language, option);
        if (locale == "fr") {
          return (
            "du " +
            format.format(new Date(this.rangesData.dates[0] * 1000)) +
            " au " +
            format.format(new Date(this.rangesData.dates[1] * 1000))
          );
        } else {
          return (
            "from the " +
            format.format(new Date(this.rangesData.dates[0] * 1000)) +
            " to the " +
            format.format(new Date(this.rangesData.dates[1] * 1000))
          );
        }
      } else {
        if (locale == "fr") {
          return "selectionnez vos dates";
        } else {
          return "select your dates";
        }
      }
    },
    toggleCalendar() {
      this.isVisible = !this.isVisible;
    },
    changeRangesData() {
      this.showModal = false;
      this.dates = this.showDates();
      var datesOK = new Event("datesOK");
      let elRDD = document.querySelector("#rsid-datepicker-data");
      let fd = this.rangesData.fullDates;
      if (fd != null) fd.dates = this.rangesData.dates;
      elRDD.dataset.dates = JSON.stringify(fd);
      elRDD.dispatchEvent(datesOK);
    }
  },
  computed: {},
  mounted() {
    let srvdata = JSON.parse(
      document.querySelector("#rsid-datepicker-data").dataset.srvdata
    );
    // eslint-disable-next-line
    //console.log(srvdata);
    this.rangesData.rangesPromo = srvdata.promo;
    if (srvdata.dates != null){
    this.rangesData.dates = srvdata.dates.dates;
    this.rangesData.fullDates = {
          nbJ: srvdata.dates.nbJ,
          pourcentage: srvdata.dates.pourcentage
        }
    }
    if(this.rangesData.dates != null) this.changeRangesData();
    this.dates = this.showDates();
  },
  updated() {
    this.dates = this.showDates();
  }
};
</script>

<style scoped>
#rsid-datepicker {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  margin-top: 60px;
  box-sizing: content-box;
  font-weight: 400;
  font-size: normal;
  font-size: 16px;
}


@media screen and (max-width: 900px) {
  #rsid-datepicker {
    font-size: 13px;
  }
}
</style>
